export const projectSwitcherId = "projectSwitcher";
